angular.module('impactx.list').service('PaginationService', [PaginationService]);

function PaginationService() {
    var self = this;
    var ROWS_PER_PAGE = 50;
    self.rowCount = undefined;
    self.numberOfLines = ROWS_PER_PAGE;
    self.numberOfLinesPerList = {};

    function resetNumberOfLinesPerList() {
        self.numberOfLinesPerList = {};
    }

    function setNumberOfLines(numberOfLines, listId) {
        if (listId) {
            self.numberOfLinesPerList[listId] = numberOfLines;
        }
        else {
            self.numberOfLines = numberOfLines;
        }
    }

    function getNumberOfLines(listId) {
        if (listId && self.numberOfLinesPerList[listId]) {
            return self.numberOfLinesPerList[listId];
        }
        else {
            return self.numberOfLines ? self.numberOfLines : ROWS_PER_PAGE;
        }
    }

    return {
        rowCount: self.rowCount,
        ROWS_PER_PAGE: ROWS_PER_PAGE,
        setNumberOfLines: setNumberOfLines,
        getNumberOfLines: getNumberOfLines,
        resetNumberOfLinesPerList: resetNumberOfLinesPerList
    };
}